export enum SideNavState {
  FULL = 'full',
  SLIM = 'slim',
  MOBILE = 'mobile',
}

export enum Requirement {
  GRADEBOOSTER = 'gradeBooster',
  HASCOURSES = 'hasCourses',
  LIVELESSONS_LIVE = 'liveLessonsLive',
  ASKAALIYAH_LIVE = 'askAaliyahLive',
  ESSAYMARKING_LIVE = 'essayMarkingLive',
}
